import {
  LayoutNodeFilter,
  LayoutNodeFilterType,
} from "@towersystems/roam-common/lib/generated-types";
import { PageItemType } from "../../../../../../utilities/layout";
import { InteractiveQuickKey } from "../../../InteractiveQuickKey";
import { useMakeCommonQuickKeyProps } from "../../hooks";
import { FilterQuickKey } from "../../quick-keys";
import { capitalize } from "lodash";

export interface FilterItemRendererProps {
  item: PageItemType;
  getNameFromFilter: (filterType: LayoutNodeFilterType, id: string) => string;
}

const GENERATED_LABEL_PREFIX = "Filter by";

const MAX_DISPLAYED_FILTERS = 3;

export function FilterItemRenderer({
  item,
  getNameFromFilter,
}: FilterItemRendererProps) {
  const { makeCommonQuickKeyProps } = useMakeCommonQuickKeyProps();
  const interactiveProps = makeCommonQuickKeyProps(item);

  const filter = item.config?.filter;

  if (!filter) {
    return null;
  }

  function generateFilterName(filter: LayoutNodeFilter) {
    const { type, values } = filter;

    if (!values || values.length === 0) {
      return `${GENERATED_LABEL_PREFIX} ${capitalize(type)}`;
    }

    const names = values
      .slice(0, MAX_DISPLAYED_FILTERS)
      .map((id) => getNameFromFilter(type, id));

    return `${GENERATED_LABEL_PREFIX} ${names.join(", ")}`;
  }

  let label = item.config?.label || "";

  if (!label) {
    label = generateFilterName(filter);
  }

  return (
    <InteractiveQuickKey {...interactiveProps}>
      <FilterQuickKey {...{ label, item }} />
    </InteractiveQuickKey>
  );
}
